export const formKey = '[Price Offer Reject Form] Form';
